"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasWindowLocalStorage = exports.EppoLocalStorage = void 0;
class EppoLocalStorage {
    constructor() {
        if (!hasWindowLocalStorage()) {
            console.warn('EppoSDK cannot store experiment configurations as window.localStorage is not available');
        }
    }
    isInitialized() {
        return hasWindowLocalStorage();
    }
    get(key) {
        if (hasWindowLocalStorage()) {
            const serializedEntry = window.localStorage.getItem(key);
            if (serializedEntry) {
                return JSON.parse(serializedEntry);
            }
        }
        return null;
    }
    getKeys() {
        if (hasWindowLocalStorage()) {
            return Object.keys(window.localStorage);
        }
        return null;
    }
    setEntries(entries) {
        if (hasWindowLocalStorage()) {
            Object.entries(entries).forEach(([key, val]) => {
                window.localStorage.setItem(key, JSON.stringify(val));
            });
        }
    }
}
exports.EppoLocalStorage = EppoLocalStorage;
// Checks whether local storage is enabled in the browser (the user might have disabled it).
function hasWindowLocalStorage() {
    try {
        return typeof window !== 'undefined' && !!window.localStorage;
    }
    catch (_a) {
        // Chrome throws an error if local storage is disabled and you try to access it
        return false;
    }
}
exports.hasWindowLocalStorage = hasWindowLocalStorage;
//# sourceMappingURL=local-storage.js.map